
const state = {
  snackbar: {
    visible: false,
    message: '',
    error: false
  }
};

const mutations = {
  SHOW_SNACKBAR(state, { message, error = false }) {
    state.snackbar.visible = true;
    state.snackbar.message = message;
    state.snackbar.error = error;
  },
  HIDE_SNACKBAR(state) {
    state.snackbar.visible = false;
    state.snackbar.message = '';
    state.snackbar.error = false;
  }
};

const actions = {
  showSnackbar({ commit }, payload) {
    commit('SHOW_SNACKBAR', payload);
  },
  hideSnackbar({ commit }) {
    commit('HIDE_SNACKBAR');
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
